import { BadgeSide } from './badgeGeometry'

export const BADGE_CONNECTION_SIDES: readonly BadgeSide[] = ['top', 'right', 'bottom', 'left']
export const BADGE_CONNECTION_HANDLE_HIT_WIDTH = 24
export const CONNECTION_SELECTION_HIT_WIDTH = 14

export function badgeConnectionHandleConfig(side: BadgeSide): Record<string, unknown> {
    return {
        radius: 6, fill: '#ffffff', stroke: '#1677a8', strokeWidth: 2,
        hitStrokeWidth: BADGE_CONNECTION_HANDLE_HIT_WIDTH,
        draggable: true, listening: true,
        name: `badge-connection-handle-${side}`,
        obj: 'badge_connection_handle', side,
    }
}

export function connectionSelectionHitWidth(lineWidth: unknown): number {
    return Math.max(CONNECTION_SELECTION_HIT_WIDTH, (Number(lineWidth) || 1) + 10)
}

/**
 * Test a page-local pointer against a routed connection. Connections are
 * page-level siblings, so their hit shape can be covered by a parent `obj`
 * when both endpoint badges live inside that object. This geometry fallback
 * lets the layer still select the connection in that covered area.
 */
export function connectionContainsPoint(connection: any, point: { x: number, y: number }): boolean {
    const x = Number(point?.x)
    const y = Number(point?.y)
    const points = connection?.routePoints
    if (!Number.isFinite(x) || !Number.isFinite(y) || !Array.isArray(points) || points.length < 2) return false

    const threshold = connectionSelectionHitWidth(connection.line_width) / 2
    const thresholdSquared = threshold * threshold
    for (let index = 1; index < points.length; index += 1) {
        const start = points[index - 1]
        const end = points[index]
        const dx = Number(end.x) - Number(start.x)
        const dy = Number(end.y) - Number(start.y)
        const lengthSquared = dx * dx + dy * dy
        const ratio = lengthSquared === 0
            ? 0
            : Math.max(0, Math.min(1, ((x - Number(start.x)) * dx + (y - Number(start.y)) * dy) / lengthSquared))
        const closestX = Number(start.x) + ratio * dx
        const closestY = Number(start.y) + ratio * dy
        const distanceX = x - closestX
        const distanceY = y - closestY
        if (distanceX * distanceX + distanceY * distanceY <= thresholdSquared) return true
    }
    return false
}

export function placeConnectionBehindPageObjects(page: any, connection: any): void {
    connection.moveToBottom?.()
    page?.rect?.moveToBottom?.()
    page?.shadow?.moveToBottom?.()
}

export function selectionAfterConnectionDrop(sourceBadge: any): any {
    return sourceBadge
}
